import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tinycolor from "tinycolor2";
import { mapState } from "vuex";
import { getFlowTitle } from "@Shared/@Utils/helpers/application";
import { textStatus } from "@Shared/@Utils/helpers/text";
import { groupBy, orderBy, trim } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InterstitialApplications",
  filters: {
    getSecondaryComplement() {
      const bodyStyles = window.getComputedStyle(document.body);
      const secondaryColor = trim(bodyStyles.getPropertyValue("--secondary"));
      return tinycolor(secondaryColor).complement().toHexString();
    },
    textStatus(applicationStatus) {
      return textStatus(applicationStatus);
    },
    getFlowTitle(flow, flows) {
      return getFlowTitle(flow, flows);
    }
  },
  props: {
    subdomains: {
      type: Object,
      required: true
    },
    selectedApplicationId: {
      type: Number,
      default: null
    },
    selectedSubdomain: {
      type: String,
      default: null
    }
  },
  computed: _objectSpread({}, mapState("DeprecatedApplicationStore", {
    flows(state) {
      const {
        metadata
      } = state.rawSchema;
      return metadata["flow-selection"];
    },
    translationMap(state) {
      return state.rawSchema.translationMap;
    }
  })),
  methods: {
    sortSubdomainsByCreatedAt() {
      let sortedObject = [];
      for (const [key, value] of _Object$entries(this.subdomains)) {
        for (const arr of value) {
          sortedObject.push(_objectSpread(_objectSpread({}, arr), {}, {
            subdomain: key
          }));
        }
      }
      sortedObject = _sortInstanceProperty(sortedObject).call(sortedObject, function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      return groupBy(sortedObject, "subdomain");
    },
    sortByCreatedAt(applications) {
      return orderBy(applications, "createdAt", "desc");
    },
    handleSelectApplication(applicationId, subdomain) {
      this.$emit("update:selectedApplicationId", applicationId);
      this.$emit("update:selectedSubdomain", subdomain);
    }
  }
});